import { derived, readable } from "svelte/store";

import { browser } from "$app/environment";

// TODO(duanei): Need to redefine this completely and then attach the values to tailwindw config
// instead.

const lightColors = {
  Accent: { h: 346, l: 55, s: 96 },
  AccentContrast: { h: 0, l: 100, s: 0 },
  N00: { h: 0, l: 100, s: 0 },
  N04: { h: 258, l: 92, s: 24 },
  N08: { h: 258, l: 96, s: 24 },
  N12: { h: 258, l: 98, s: 24 },
  N16: { h: 258, l: 88, s: 24 },
  N20: { h: 258, l: 90, s: 24 },
  N32: { h: 258, l: 80, s: 24 },
  N59: { h: 258, l: 40, s: 24 },
  N77: { h: 258, l: 24, s: 24 },
  N100: { h: 0, l: 0, s: 0 },
  PrimaryText: { h: 0, l: 0, s: 0 },
  SecondaryText: { h: 259, l: 24, s: 24 },
} as const;

const darkColors = {
  Accent: { h: 346, l: 55, s: 96 },
  AccentContrast: { h: 0, l: 100, s: 0 },
  N00: { h: 0, l: 0, s: 0 },
  N04: { h: 258, l: 4, s: 24 },
  N08: { h: 258, l: 8, s: 24 },
  N12: { h: 258, l: 12, s: 24 },
  N16: { h: 258, l: 16, s: 24 },
  N20: { h: 258, l: 20, s: 24 },
  N32: { h: 258, l: 32, s: 24 },
  N59: { h: 258, l: 59, s: 24 },
  N77: { h: 258, l: 77, s: 24 },
  N100: { h: 0, l: 100, s: 0 },
  PrimaryText: { h: 0, l: 100, s: 0 },
  SecondaryText: { h: 257, l: 77, s: 24 },
} as const;

const gxCornerfallbackConfig = readable<Oprt["gxCornerConfig"]>(
  {
    colors: darkColors,
    contentInsets: { left: 16, right: 16 },
    // TODO(duanei): Need to update this now that fallback always is used outside of webview.
    deviceKind: "desktop",
    newsLocales: ["en-US"],
    platform: "desktop",
    proxyUrl: import.meta.env.VITE_PROXY_URL,
    sysLocales: ["en-US"],
  },
  (set) => {
    if (!browser) {
      return;
    }

    const mediaQuery = window.matchMedia("(prefers-color-scheme: light)");
    const setConfig = (light: boolean) =>
      set({
        colors: light ? lightColors : darkColors,
        contentInsets: { left: 16, right: 16 },
        deviceKind: "desktop",
        newsLocales: ["en-US"],
        platform: "desktop",
        proxyUrl: import.meta.env.VITE_PROXY_URL,
        sysLocales: ["en-US"],
      });

    setConfig(mediaQuery.matches);
    const handler = ({ matches }: MediaQueryListEvent) => setConfig(matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  },
);

const gxCornerRemoteConfig = readable<Oprt["gxCornerConfig"] | undefined>(
  browser ? window.oprt?.gxCornerConfig : undefined,
  (set) => {
    if (!browser) {
      return;
    }

    set(window.oprt?.gxCornerConfig);
    const handler = () => set(window.oprt?.gxCornerConfig);
    window.addEventListener("onconfigchange", handler);
    return () => window.removeEventListener("onconfigchange", handler);
  },
);

export const remoteConfig = derived(
  [gxCornerRemoteConfig, gxCornerfallbackConfig],
  ([$remote, $fallback]): Oprt["gxCornerConfig"] => $remote || $fallback,
);
